const updates = [
  { date: '2024-08-01', title: '《庆余年 第二季》全集上线，会员抢先看完结篇', tag: '热剧上线' },
  { date: '2024-07-30', title: '暑期档特辑上线！十部高分国产电影限时推荐', tag: '专题活动' },
  { date: '2024-07-28', title: '《间谍过家家 第二季》更新至第 12 集', tag: '番剧更新' },
  { date: '2024-07-26', title: '《三体》电视剧 4K 修复版上线，画质全面升级', tag: '资源升级' },
  { date: '2024-07-24', title: '韩剧专区新增五部高分热剧，追剧选择更丰富', tag: '内容扩充' },
  { date: '2024-07-22', title: '播放器升级完成，加载速度和画质均有提升', tag: '技术优化' },
  { date: '2024-07-20', title: '《流浪地球 3》专题页面上线，收录系列全作品', tag: '专题推荐' },
  { date: '2024-07-18', title: '纪录片专区全新改版，新增 BBC 经典系列合集', tag: '专区升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">最新动态</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">小辣椒影院的资源更新与平台动态一览</p>
        <div className="relative">
          <div className="absolute left-5 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-0">
            {updates.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 md:gap-6 pb-6 last:pb-0 pl-12 md:pl-14">
                <div className="absolute left-3.5 md:left-4.5 top-0.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-accent-500 border-2 border-background-100 flex-shrink-0"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="text-xs bg-primary-100 text-primary-700 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-800 font-medium leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}